var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPackingSlipPrinted = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 30,
  height: 30,
  viewBox: "9 7 12 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M9 22.999h12V7H9zm4.999-11.5h5v-1.5h-5zm-2.999.5h2v-2h-2zm2.999 3.5h5v-1.5h-5zM11 16h2v-2.001h-2zm2.999 3.5h5V18h-5zM11 20h2v-2h-2z"
})));
export default SvgPackingSlipPrinted;